export const MAX_AMOUNT_IMAGES_PER_POST = 20;
export const ALL_COMMUNITY_FEED_TABS = [
  "all",
  "announcements",
  "myFeed",
  "own",
  "question",
  "scheduled",
  "deleted",
] as const;

export const DEFAULT_COMMUNITY_FEED_TAB_ADMIN: (typeof ALL_COMMUNITY_FEED_TABS)[number] = "announcements";
export const DEFAULT_COMMUNITY_FEED_TAB_RESIDENT: (typeof ALL_COMMUNITY_FEED_TABS)[number] = "myFeed";
